import React, { PropTypes as T } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';

import AxiosService from '../../utils/axios-service';
import TextInput from '../../components/form-input-text';
import { EMAIL_REGULAR_EXPRESSION } from '../../utils/form-input-validation';
import { reportError } from '../../utils/error-handling-service';

import ThemeSelector from '../../themes/theme-selector';

const theme = ThemeSelector.theme();

class ResetPassword extends React.Component {
  static contextTypes = {
    router: T.object,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      resetSentSuccess: false,
      requestError: false,
      email: null,
    };
  }

  resetPassword(data) {
    const context = this;

    const email = data.get('email');

    context.setState({ email });

    const axiosService = new AxiosService('https://dyzio.eu.auth0.com/', process.env.REACT_APP_API_TIMEOUT, {});

    const insertParams = {
      client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
      email,
      connection: 'Username-Password-Authentication',
      json: true,
    };

    axiosService.post('dbconnections/change_password', insertParams)
      .then(() => {
        context.setState({ resetSentSuccess: true, requestError: false });
      }, error => {
        reportError('RESET_PASSWORD_ERROR', error.message);
        context.setState({ resetSentSuccess: false, requestError: error.message });
      },
      );
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="page-centered">
        <div className="center-outer">
          <div className="center-inner">
            <div className="center-logo">
              <a onClick={() => this.context.router.push('/')}>
                <img src={theme.darkLogo.src} alt={theme.darkLogo.alt} />
              </a>
            </div>
            { !this.state.resetSentSuccess &&
              <div className="center-content">
                <p className="info">
                  Forgotten your password? Enter your email address and we’ll send you a link to set a new one.
                </p>
                <div className="spacer" />
                <form onSubmit={handleSubmit(this.resetPassword.bind(this))}>
                  <Field
                    name="email"
                    type="text"
                    component={TextInput}
                    img="/icons/email.svg"
                    placeholder="Email address"
                  />
                  { this.state.requestError &&
                    <p className="error">
                      Request has failed: {this.state.requestError}
                    </p>
                  }
                  <button type="submit" className="large rose stretch">
                    <p>Reset password</p>
                  </button>
                </form>
              </div>
            }
            { this.state.resetSentSuccess && !this.state.requestError &&
              <div className="center-content">
                <div className="info-image">
                  <img src="/icons/large-success-seagreen.svg" alt="Success" />
                </div>
                <div className="spacer" />
                <h2 className="info">Message sent</h2>
                <p className="info">Please check your inbox and click the link in the email we sent you to reset your password.</p>
                <div className="spacer" />
                <p className="info">
                  <a onClick={() => this.context.router.push('/login')}>Back to log in</a>
                </p>
                <div className="spacer" />
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  const email = values.get('email');

  if (!email) errors.email = 'Enter a valid email address.';
  if (email && !EMAIL_REGULAR_EXPRESSION.test(email)) errors.email = 'Enter a valid email address.';

  return errors;
}

export default reduxForm({
  form: 'ResetPasswordForm',
  validate,
})(ResetPassword);



/** WEBPACK FOOTER **
 ** ./src/containers/reset-password/index.js
 **/